export default __webpack_public_path__ + "static/media/aerial_platform_bw_cropped.87d110e1.jpg";